// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/expressive_reports" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementQueryBuilderReports } from "./constants";
import type { QueryBuilderReportParams, QueryBuilderReportResult } from "./types";

export const getEngagementQueryBuilderReports = reactQueryTableFetcherAdapter(
  engagementQueryBuilderReports,
  async (
    signal,
    { query, limit = 20, start = 0, sortdir, sortby, ...rest }: QueryBuilderReportParams
  ): Promise<QueryBuilderReportResult> => {
    return fetch(
      engagementQueryBuilderReports,
      "GET",
      {
        limit,
        sortby,
        sortdir,
        start,
        query: serializeQueryObjects(query),
        ...rest,
      },
      { signal }
    );
  }
);
